<template lang="html">
  <div class="comment-item" @click="commentLog(flagLog, index)">
    <div class="avatar">
      <img :src="comment.user.photo | avatarComment(80, 80)" alt="" />
    </div>
    <div class="comment-user">
      <div class="wrap-start-name">
        <div class="user-name">
          <p>{{ name(comment.user) }}</p>
          <div class="comment-time">
            <time>{{ timeFormat(comment.created_at * 1000) }}</time>
          </div>
        </div>

        <star
          class="start-list"
          size="medium"
          :score="comment.score"
          color="#FFB320"
        ></star>
      </div>
      <div class="comment-content" :class="{ 'ommit-content': ommitContent }">
        <span class="dot" v-if="comment.extend && comment.extend.skuTitle"
          >{{ comment.extend.skuTitle }}：</span
        >{{ comment.content }}
      </div>
      <div class="server-person" v-if="comment.community_info && showServer">
        <userProfile
          :showArrow="true"
          :canServe="true"
          :user="user(comment.community_info)"
          v-on:userDetail="getUserID"
        ></userProfile>
      </div>
      <div
        class="comment-imgs"
        v-if="comment.image_urls && comment.image_urls.length > 0"
      >
        <ul>
          <li
            v-for="(image, index) in comment.image_urls"
            @click="showImage(imgLog, comment.image_urls, index)"
          >
            <img v-lazy="$$viewImageInCenter(image, 203, 203)" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import userProfile from '@/components/user/profile'
import star from '@/components/common/star2020'

export default {
  props: {
    comment: {
      type: Object,
      default() {
        return {}
      }
    },
    showServer: {
      type: Boolean,
      default: true
    },
    ommitContent: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    flagLog: {
      type: Boolean,
      default: false
    },
    imgLog: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    user(obj) {
      let schedualAreas = []
      if (obj.service.length > 0) {
        schedualAreas = obj.service.map(ele => ({
          districtName: ele
        }))
      }
      return {
        is_del: obj.is_del,
        headPicUrl: obj.photo,
        uid: obj.uid,
        name: obj.name,
        score: obj.score,
        schedualAreas
      }
    },
    name(val) {
      const nickname = val.nickname
      if (nickname.length > 1) {
        return `${nickname.charAt(0)}***${nickname.charAt(nickname.length - 1)}`
      } else if (nickname.length === 1) {
        return `${nickname.charAt(0)}***`
      } else {
        return `用户${val.uid}`
      }
    },
    getUserID(user) {
      if (user.is_del === 0 || !user.uid) {
        // 离职
        return
      }
      this.$$tracker('100101', '20000', 21030)
      // if (user.source !== 'pop') {
      //     location.href = `${this.$$hostname('shequ')}/bbs/user/${user.uid}`
      // } else {
      location.href = `/v/user/${user.uid}`
      // }
    },
    showImage(imgLog, images, index) {
      if (imgLog) {
        this.$$tracker('140101', '20000', '21128')
      }
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    timeFormat(time) {
      const now = new Date()
      const now_y = now.getFullYear()
      const date = new Date(time)
      const date_y = date.getFullYear()
      if (now_y === date_y) {
        return this.$$dateFormat(time, 'MM-DD')
      } else {
        return this.$$dateFormat(time, 'YY-MM-DD')
      }
    },
    commentLog(flagLog, key) {
      if (flagLog) {
        const index = key + 1
        this.$$tracker('140101', '20000', '21123', index)
      }
    }
  },
  components: {
    userProfile,
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.comment-item {
  display: flex;
  padding: rem(30px) 0;
  font-size: rem(28px);
  background: #fff;
  @include border(bottom);
  overflow: hidden;

  &:last-of-type {
    &::after {
      display: none;
    }
  }

  .avatar {
    width: rem(80px);
    height: rem(80px);
    margin-right: rem(20px);
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .wrap-start-name {
    height: rem(80px);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .comment-user {
    flex: 1;
  }
  .user-name {
    display: flex;
    color: #666;
    font-size: rem(28px);
    line-height: rem(34px);
    align-items: center;
    justify-content: space-between;
    > p {
      flex: 1;
      line-height: rem(34px);
    }
  }
  .start-list {
    margin-top: rem(8px);
  }
  .star-content {
    display: flex;
    align-items: flex-start;
    font-size: rem(28px);
  }
  .comment-content {
    margin-top: rem(24px);
    word-break: break-all;
    color: #121212;
    font-size: rem(28px);
    line-height: rem(40px);
    .dot {
      color: #fe3a7f;
    }
  }
  .ommit-content {
    display: -webkit-box;
    word-break: break-all;
    text-align: left;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 4.5em;
    overflow: hidden;
  }
  .server-person {
    margin-top: rem(28px);
  }
  .comment-imgs {
    margin-top: rem(20px);
    ul {
      display: flex;
      height: rem(160px);
      overflow: hidden;
    }

    li {
      position: relative;
      width: rem(160px);
      height: rem(160px);
      margin-right: rem(20px);
      img {
        // max-width: 100%;
        width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .comment-time {
    color: #999;
    font-size: rem(24px);
  }
}
</style>
